<template>
  <div class="page-wrapper admin-stats-sheet admin-stats-sheet--cols-4">
    <div class="stats-row">
      <div class="mini-stat" v-for="s in coachStats" :key="s.label">
        <div class="mini-stat-icon" :style="{ background: s.bg, color: s.color }"><component :is="s.icon" /></div>
        <div><p class="mini-stat-val">{{ s.value }}</p><p class="mini-stat-label">{{ s.label }}</p></div>
      </div>
    </div>

    <div class="page-toolbar admin-list-toolbar">
      <div class="page-toolbar-left">
        <div class="filter-tabs">
          <button v-for="tab in coachFilterTabs" :key="tab.v" type="button" class="filter-tab"
            :class="{ active: coachFilterTab === tab.v }" @click="coachFilterTab = tab.v">{{ tab.l }}</button>
        </div>
        <div class="search-box">
          <el-icon><Search /></el-icon>
          <input v-model="searchQuery" type="text" placeholder="搜索姓名、专长" />
        </div>
      </div>
      <div class="page-toolbar-right">
        <div class="view-toggle">
          <button type="button" class="view-btn" :class="{ active: viewMode === 'grid' }" @click="setViewMode('grid')"><el-icon><Grid /></el-icon></button>
          <button type="button" class="view-btn" :class="{ active: viewMode === 'list' }" @click="setViewMode('list')"><el-icon><List /></el-icon></button>
        </div>
        <button class="btn-primary" @click="openAdd"><el-icon><Plus /></el-icon><span>新增教练</span></button>
      </div>
    </div>

    <div v-if="viewMode === 'grid'" class="coach-grid">
      <div class="coach-card" v-for="coach in filteredCoaches" :key="coach.id">
        <div class="coach-card-top">
          <div class="coach-avatar" :style="{ background: coach.avatarBg }">{{ (coach.name || '?').charAt(0) }}</div>
          <span class="coach-status-badge" :class="coach.status">{{ coach.statusLabel }}</span>
        </div>
        <div class="coach-card-body">
          <h3 class="coach-name">{{ coach.name }}</h3>
          <p class="coach-title">{{ coach.title }}</p>
          <div class="coach-tags">
            <span class="coach-tag" v-for="tag in coach.specialties" :key="tag">{{ tag }}</span>
          </div>
          <div class="coach-stats">
            <div class="c-stat"><p class="c-stat-val">{{ coach.members }}</p><p class="c-stat-label">学员</p></div>
            <div class="c-stat"><p class="c-stat-val">{{ coach.courses }}</p><p class="c-stat-label">课程</p></div>
            <div class="c-stat"><p class="c-stat-val">{{ coach.ratingLabel }}</p><p class="c-stat-label">评分</p></div>
          </div>
          <div class="coach-footer">
            <span class="coach-phone"><el-icon><Phone /></el-icon>{{ coach.phone }}</span>
            <div class="coach-actions">
              <button class="act-btn edit" @click="editCoach(coach)"><el-icon><Edit /></el-icon></button>
              <button class="act-btn del" @click="deleteCoach(coach)"><el-icon><Delete /></el-icon></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="table-card">
      <el-table :data="filteredCoaches" style="width:100%" :header-cell-style="headerStyle">
        <el-table-column type="index" label="#" width="55" />
        <el-table-column label="教练" min-width="140">
          <template #default="{ row }">
            <div class="coach-cell">
              <span class="coach-cell-avatar" :style="{ background: row.avatarBg }">{{ (row.name || '?').charAt(0) }}</span>
              <span>{{ row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="职称" width="120" />
        <el-table-column prop="phone" label="手机" width="120" />
        <el-table-column label="状态" width="100">
          <template #default="{ row }"><span class="coach-status-badge" :class="row.status">{{ row.statusLabel }}</span></template>
        </el-table-column>
        <el-table-column label="专长" min-width="160" show-overflow-tooltip>
          <template #default="{ row }">{{ row.specialty || '-' }}</template>
        </el-table-column>
        <el-table-column prop="ratingLabel" label="评分" width="80" />
        <el-table-column label="操作" width="100" fixed="right">
          <template #default="{ row }">
            <div class="table-actions">
              <button type="button" class="act-btn edit" @click="editCoach(row)"><el-icon><Edit /></el-icon></button>
              <button type="button" class="act-btn del" @click="deleteCoach(row)"><el-icon><Delete /></el-icon></button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog v-model="showDialog" :title="editing ? '编辑教练' : '新增教练'" width="540px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="姓名"><el-input v-model="form.name" placeholder="请输入姓名" /></el-form-item>
        <el-form-item label="职称"><el-input v-model="form.title" placeholder="如：高级健身教练" /></el-form-item>
        <el-form-item label="手机号"><el-input v-model="form.phone" placeholder="请输入手机号" /></el-form-item>
        <el-form-item label="专长"><el-input v-model="form.specialty" placeholder="如：力量训练,有氧运动（逗号分隔）" /></el-form-item>
        <el-form-item label="资质证书"><el-input v-model="form.certificate" placeholder="如：国家级健身教练证" /></el-form-item>
        <el-form-item label="从业年限"><el-input-number v-model="form.experience" :min="0" :max="50" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="在职" :value="1" />
            <el-option label="离职" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <button class="btn-secondary" @click="showDialog=false">取消</button>
          <button class="btn-primary" @click="saveCoach">保存</button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Search, Plus, Edit, Delete, Phone, UserFilled, TrendCharts, Star, Trophy, Grid, List } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import api from '@/api/request';
import adminListViewModeMixin from '@/mixins/adminListViewMode';

export default {
  name: 'CoachView',
  mixins: [adminListViewModeMixin],
  components: { Search, Plus, Edit, Delete, Phone, UserFilled, TrendCharts, Star, Trophy, Grid, List },
  data() {
    return {
      coachFilterTab: 'all',
      coachFilterTabs: [
        { v: 'all', l: '全部' },
        { v: '1', l: '在职' },
        { v: '0', l: '离职' },
      ],
      searchQuery: '',
      showDialog: false,
      editing: null,
      form: { name: '', title: '', phone: '', specialty: '', certificate: '', experience: 1, rating: 45, status: 1 },
      coachStats: [
        { label: '在职教练', value: '-', icon: 'UserFilled', bg: 'rgba(0,98,255,0.1)', color: '#0062FF' },
        { label: '认证教练', value: '-', icon: 'Trophy', bg: 'rgba(139,92,246,0.1)', color: '#8B5CF6' },
        { label: '好评率', value: '-', icon: 'Star', bg: 'rgba(245,158,11,0.1)', color: '#F59E0B' },
        { label: '平均经验', value: '-', icon: 'TrendCharts', bg: 'rgba(16,185,129,0.1)', color: '#10B981' },
      ],
      coaches: []
    };
  },
  computed: {
    filteredCoaches() {
      let list = this.coaches;
      if (this.coachFilterTab === '1') {
        list = list.filter(c => Number(c.statusCode) === 1);
      } else if (this.coachFilterTab === '0') {
        list = list.filter(c => Number(c.statusCode) === 0);
      }
      const q = (this.searchQuery || '').trim();
      if (!q) return list;
      return list.filter(c =>
        (c.name && c.name.includes(q)) ||
        (c.specialty || '').includes(q)
      );
    },
    headerStyle() {
      return { background: 'var(--bg-elevated)', color: 'var(--text-secondary)', fontWeight: 500 };
    },
  },
  mounted() {
    this.loadCoaches();
  },
  methods: {
    coachStatusToInt(status) {
      if (status === true) return 1;
      if (status === false) return 0;
      const n = Number(status);
      return Number.isFinite(n) ? n : 0;
    },
    async loadCoaches() {
      try {
        const res = await api.getCoachList();
        const body = res && res.data;
        const ok = body && (body.code === 200 || body.code === '200' || Number(body.code) === 200);
        if (!ok) {
          ElMessage.error((body && (body.message || body.msg)) || '加载教练列表失败');
          return;
        }
        let list = body.data;
        if (!Array.isArray(list)) list = [];
        const colors = ['#0062FF', '#10B981', '#EF4444', '#EC4899', '#8B5CF6', '#F59E0B', '#06B6D4'];
        this.coaches = list.map((c, i) => {
          const coachId = c.coachId != null ? c.coachId : c.coach_id;
          const st = this.coachStatusToInt(c.status);
          const ratingNum = c.rating != null ? Number(c.rating) : null;
          return {
            ...c,
            coachId,
            id: coachId,
            statusCode: st,
            specialties: c.specialty ? String(c.specialty).split(',') : [],
            members: 0,
            courses: 0,
            ratingLabel: ratingNum != null && !Number.isNaN(ratingNum) ? (ratingNum / 10).toFixed(1) : '-',
            status: st === 1 ? 'active' : 'leave',
            statusLabel: st === 1 ? '在职' : '离职',
            avatarBg: colors[i % colors.length],
          };
        });
        const active = list.filter(c => this.coachStatusToInt(c.status) === 1).length;
        const certified = list.filter(c => c && c.certificate).length;
        const avgExp = list.length ? Math.round(list.reduce((s, c) => s + (Number(c.experience) || 0), 0) / list.length) : 0;
        this.coachStats[0].value = String(active);
        this.coachStats[1].value = String(certified);
        this.coachStats[3].value = avgExp + '年';
      } catch (e) {
        ElMessage.error('加载教练列表失败，请检查网络或重新登录');
      }
    },
    openAdd() {
      this.editing = null;
      this.form = { name: '', title: '', phone: '', specialty: '', certificate: '', experience: 1, rating: 45, status: 1 };
      this.showDialog = true;
    },
    editCoach(c) {
      this.editing = c;
      this.form = {
        coachId: c.coachId,
        name: c.name,
        title: c.title,
        phone: c.phone,
        specialty: c.specialty,
        certificate: c.certificate,
        experience: c.experience,
        rating: typeof c.rating === 'number' ? c.rating : 45,
        status: Number(c.statusCode) === 1 ? 1 : 0,
      };
      this.showDialog = true;
    },
    async deleteCoach(c) {
      try {
        await ElMessageBox.confirm('确定删除教练 ' + c.name + '？', '提示', { type: 'warning' });
        const res = await api.removeCoach(c.coachId);
        if (res.data && res.data.code === 200) {
          ElMessage.success('删除成功');
          this.loadCoaches();
        } else {
          ElMessage.error(res.data?.message || '删除失败');
        }
      } catch (e) {
        if (e !== 'cancel') ElMessage.error('操作失败');
      }
    },
    async saveCoach() {
      try {
        const form = { ...this.form };
        let res;
        if (this.editing) {
          res = await api.updateCoach(form);
        } else {
          res = await api.saveCoach(form);
        }
        if (res.data && res.data.code === 200) {
          ElMessage.success('保存成功');
          this.showDialog = false;
          this.loadCoaches();
        } else {
          ElMessage.error(res.data?.message || '保存失败');
        }
      } catch (e) {
        ElMessage.error('保存失败');
      }
    }
  }
};
</script>

<style scoped>
.page-wrapper { padding: 0; background: var(--bg-base); min-height: 100vh; }
.page-title { font-size: 22px; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.breadcrumb { font-size: 13px; color: var(--text-muted); display: flex; gap: 6px; }
.breadcrumb .sep { color: var(--border-color); }
.breadcrumb .cur { color: var(--primary-blue); font-weight: 500; }
.filter-tabs { display: flex; gap: 6px; flex-wrap: wrap; }
.filter-tab { padding: 6px 16px; border: 1px solid var(--border-color); background: var(--bg-gray); color: var(--text-secondary); border-radius: var(--radius-sm); font-size: 13px; font-weight: 500; cursor: pointer; transition: all 0.3s; }
.filter-tab:hover { border-color: var(--primary-blue); color: var(--primary-blue); }
.filter-tab.active { background: var(--primary-blue); border-color: var(--primary-blue); color: white; }
.view-toggle { display: flex; gap: 4px; }
.view-btn { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; border: 1px solid var(--border-color); background: var(--bg-white); color: var(--text-muted); border-radius: var(--radius-sm); cursor: pointer; transition: all 0.3s; }
.view-btn.active { background: rgba(0, 98, 255, 0.1); color: var(--primary-blue); border-color: var(--primary-blue); }
.search-box { display: flex; align-items: center; background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-md); padding: 0 12px; height: 38px; min-width: 200px; max-width: 280px; flex: 1; gap: 8px; transition: all 0.3s; }
.search-box:focus-within { border-color: var(--primary-blue); box-shadow: 0 0 0 3px rgba(0,98,255,0.08); }
.search-box .el-icon { color: var(--text-muted); }
.search-box input { border: none; background: transparent; color: var(--text-primary); font-size: 14px; outline: none; flex: 1; }
.search-box input::placeholder { color: var(--text-muted); }
.btn-primary { display: inline-flex; align-items: center; gap: 6px; padding: 0 18px; height: 38px; background: var(--gradient-primary); color: white; border: none; border-radius: var(--radius-md); font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.3s; }
.btn-primary:hover { transform: translateY(-1px); box-shadow: var(--shadow-glow); }
.btn-secondary { display: inline-flex; align-items: center; gap: 6px; padding: 0 18px; height: 38px; background: var(--bg-gray); color: var(--text-primary); border: 1px solid var(--border-color); border-radius: var(--radius-md); font-size: 14px; cursor: pointer; transition: all 0.3s; }
.btn-secondary:hover { border-color: var(--primary-blue); color: var(--primary-blue); }
.mini-stat { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-lg); padding: 16px 20px; display: flex; align-items: center; gap: 14px; transition: all 0.3s; }
.mini-stat:hover { transform: 
translateY(-2px); box-shadow: var(--shadow-lg); }
.mini-stat-icon { width: 44px; height: 44px; border-radius: var(--radius-md); display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
.mini-stat-val { font-size: 22px; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; font-family: 'Inter', sans-serif; }
.mini-stat-label { font-size: 12px; color: var(--text-muted); margin: 0; }
.coach-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 20px; }
.coach-card { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-xl); overflow: hidden; transition: all 0.3s; }
.coach-card:hover { transform: translateY(-4px); box-shadow: var(--shadow-xl); }
.coach-card-top { background: var(--gradient-primary); padding: 24px 20px 20px; display: flex; align-items: flex-start; justify-content: space-between; }
.coach-avatar { width: 64px; height: 64px; border-radius: 50%; background: rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center; color: white; font-size: 26px; font-weight: 700; border: 3px solid rgba(255,255,255,0.4); }
.coach-status-badge { padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: 600; }
.coach-status-badge.active { background: rgba(16,185,129,0.2); color: #10B981; border: 1px solid rgba(16,185,129,0.3); }
.coach-status-badge.leave { background: rgba(245,158,11,0.2); color: #F59E0B; border: 1px solid rgba(245,158,11,0.3); }
.coach-card-body { padding: 16px; }
.coach-name { font-size: 17px; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.coach-title { font-size: 13px; color: var(--text-secondary); margin: 0 0 12px; }
.coach-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 14px; }
.coach-tag { padding: 3px 10px; background: rgba(0,98,255,0.08); color: var(--primary-blue); border-radius: 20px; font-size: 11px; font-weight: 600; }
.coach-stats { display: flex; gap: 0; margin-bottom: 14px; border: 1px solid var(--border-color); border-radius: var(--radius-md); overflow: hidden; }
.c-stat { flex: 1; text-align: center; padding: 10px 4px; border-right: 1px solid var(--border-color); }
.c-stat:last-child { border-right: none; }
.c-stat-val { font-size: 16px; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; font-family: 'Inter', sans-serif; }
.c-stat-label { font-size: 11px; color: var(--text-muted); margin: 0; }
.coach-footer { display: flex; align-items: center; justify-content: space-between; }
.coach-phone { font-size: 12px; color: var(--text-muted); display: flex; align-items: center; gap: 4px; }
.coach-actions { display: flex; gap: 6px; }
.act-btn { width: 30px; height: 30px; border: none; border-radius: var(--radius-sm); display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.3s; font-size: 14px; }
.act-btn.edit { background: rgba(245,158,11,0.1); color: #F59E0B; }
.act-btn.edit:hover { background: #F59E0B; color: white; }
.act-btn.del { background: rgba(239,68,68,0.1); color: #EF4444; }
.act-btn.del:hover { background: #EF4444; color: white; }
.table-card { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-lg); overflow: hidden; }
.coach-cell { display: flex; align-items: center; gap: 10px; }
.coach-cell-avatar { width: 32px; height: 32px; border-radius: var(--radius-md); display: flex; align-items: center; justify-content: center; color: white; font-weight: 700; font-size: 14px; flex-shrink: 0; }
.table-actions { display: flex; gap: 6px; }
.dialog-footer { display: flex; justify-content: flex-end; gap: 10px; }

@media (max-width: 480px) {
  .coach-grid { grid-template-columns: 1fr; gap: 14px; }
}
</style>
